<template>
  <div>
    <client-loader :client-id="clientId" v-model="client" />

    <client-posts-toolbar
      v-if="client"
      :client="client"
      v-model:filters="filters"
    />
    <posts-order
      :order="filters.order"
      class="q-my-sm q-mr-sm"
      flat
      @changed="filters.order = $event"
    />

    <pagination-mode v-model="paginationMode" flat />

    <posts
      v-if="filters.socialSiteIds.length"
      :filters="filters"
      :persist="paginationMode === 'scroll'"
      :infinite-scroll="paginationMode === 'scroll'"
      :new-page-top="paginationMode === 'manual'"
    >
      <template v-slot="{ visiblePosts }">
        <posts-grid :posts="visiblePosts">
          <template v-slot="post">
            <post
              :post="post"
              scrollable
            />
          </template>
        </posts-grid>
      </template>
    </posts>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, PostFilters } from '@/type';
import { status } from '@/social/post/post';
import Posts from '@/social/post/list/Posts.vue';
import PaginationMode from '@/social/post/list/PaginationMode.vue';
import PostsOrder from '@/social/post/list/PostsOrder.vue';
import ClientPostsToolbar from '@/social/post/list/client/ClientPostsToolbar.vue';
import Post from '@/social/post/card/Post.vue';
import PostsGrid from '@/social/post/list/PostsGrid.vue';
import ClientLoader from '@/client/ClientLoader.vue';

interface Data {
  client: Client|null,
  filters: PostFilters,
  paginationMode: string,
}

export default defineComponent({
  components: {
    ClientLoader,
    PostsGrid,
    Post,
    ClientPostsToolbar,
    Posts,
    PostsOrder,
    PaginationMode,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      client: null,
      filters: {
        clientIds: [this.clientId],
        statuses: [
          status.UNREVIEWED,
          status.SAVED,
          status.ESCALATED,
          status.RESOLVED,
        ],
        socialSiteIds: [],
        categoryIds: {},
        isTrashed: false,
        since: null,
        until: null,
        order: 'desc',
      },
      paginationMode: 'scroll',
    };
  },
});
</script>
